import { ReactNode, useEffect, useState } from 'react';
import { ResizableNavbar } from './ResizableNavbar';
import { Footer } from './footer';
import { useLocation } from 'react-router-dom';
import { PageType } from '@/types/navigation';
import { ANIM } from '@/lib/animations';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const [routeKey, setRouteKey] = useState(0);

  // Update a key on location change to trigger entry animation
  useEffect(() => {
    setRouteKey((k) => k + 1);
  }, [location.pathname]);
  
  // Map route paths to page types for the navbar
  const getPageType = (): PageType => {
    switch (location.pathname) {
      case '/':
        return 'home';
      case '/quick-start':
        return 'tutorial';
      case '/templates':
        return 'templates';
      case '/blog':
        return 'blog';
      case '/supported-nodes':
        return 'supported-nodes';
      case '/docs':
        return 'docs';
      case '/extension':
        return 'extension';
      case '/faq':
        return 'faq';
      case '/pricing':
        return 'pricing';
      case '/contact':
        return 'contact';
      case '/upload':
        return 'upload';
      case '/login':
        return 'login';
      default:
        return 'home';
    }
  };

  return (
    <div className="min-h-screen flex flex-col grid-background">
      <ResizableNavbar />
      <main
        id="main"
        role="main"
        tabIndex={-1}
        className="flex-1 focus:outline-none"
      >
        <div
          key={routeKey}
          className="w-full"
        >
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
